"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSS = void 0;
const theme_1 = require("../theme");
exports.CSS = {
    container: 'c-Accordion',
    header: 'c-Accordion__header',
    subtitle: 'c-Accordion__subtitle',
    body: 'c-Accordion__body',
};
(0, theme_1.addStyles)({
    [exports.CSS.container]: {
        border: '1px solid #ccc',
        'border-radius': '4px',
        overflow: 'hidden',
    },
    [exports.CSS.header]: {
        cursor: 'pointer',
        padding: theme_1.DefaultTheme.space(3),
        'font-weight': 'bold',
        'font-size': '115%',
        display: 'flex',
        'align-items': 'center',
        gap: theme_1.DefaultTheme.space(2),
        'user-select': 'none',
        'list-style': 'none',
        '&::-webkit-details-marker': {
            display: 'none',
        },
        '&:hover': {
            background: theme_1.DefaultTheme.background.lightGrey,
        },
        '&::after': {
            content: '""',
            display: 'inline-block',
            width: '8px',
            height: '8px',
            'border-right': '2px solid currentColor',
            'border-bottom': '2px solid currentColor',
            transform: 'rotate(45deg)',
            transition: 'transform 0.2s ease',
            'flex-shrink': 0,
            'margin-right': theme_1.DefaultTheme.space(1),
        },
        '& > span': {
            flex: '1',
            display: 'inline-flex',
            'align-items': 'center',
        },
    },
    [`${exports.CSS.container}[open] > .${exports.CSS.header}::after`]: {
        transform: 'rotate(-135deg)',
        'margin-bottom': '-4px',
    },
    [`${exports.CSS.header} .${exports.CSS.subtitle}`]: {
        'font-size': '0.9em',
        'margin-left': '8px',
        opacity: '0.7',
        'vertical-align': 'middle',
    },
    [exports.CSS.body]: {
        padding: theme_1.DefaultTheme.space(3),
        'border-top': '1px solid #ccc',
    },
});
//# sourceMappingURL=accordion.style.js.map